class WishlistGrid extends HTMLElement {
  connectedCallback () {
    this.initialised = false

    this.backEl = this.querySelector('[data-wishlist-grid-el="backButton"]')
    this.headingBlock = this.querySelector('[data-wishlist-grid-el="headerBlock"]')
    this.headingEl = this.querySelector('[data-wishlist-grid-el="headerTitle"]')
    this.manageEl = this.querySelector('[data-wishlist-grid-el="manageButton"]')
    this.manageContainer = this.querySelector('[data-wishlist-grid-el="manageContainer"]')
    this.deleteEl = this.querySelector('[data-wishlist-grid-el="deleteButton"]')
    this.editEl = this.querySelector('[data-wishlist-grid-el="editButton"]')
    this.editDialog = this.querySelector('[data-wishlist-grid-el="editDialog"]')
    this.editInput = this.querySelector('[data-wishlist-grid-el="editInput"]')
    this.editCancel = this.querySelector('[data-wishlist-grid-el="editCancel"]')
    this.editUpdate = this.querySelector('[data-wishlist-grid-el="editUpdate"]')

    this.emptyEl = this.querySelector('[data-wishlist-grid-el="empty"]')
    this.gridEl = this.querySelector('[data-wishlist-grid-el="grid"]')
    this.wishlistEl = this.querySelector('[data-wishlist-grid-el="wishlist"]')

    this.wishlistTemplate = this.querySelector('[data-wishlist-grid-el="template-wishlist"]')
    this.productTemplate = this.querySelector('[data-wishlist-grid-el="template-product"]')

    this.setUpListeners()
  }

  setUpListeners () {
    window.addEventListener(window.theme.wishlist.eventBus.wishlist_ready, () => {
      if (!this.initialised) {
        this.initialise()
      }

      this.initialised = true
    })

    window.addEventListener(window.theme.wishlist.eventBus.wishlist_removed, (event) => {
      this.showDefaultView()
    })

    this.backEl.addEventListener('click', () => {
      this.showDefaultView()
    })

    this.manageEl.addEventListener('click', () => {
      this.manageContainer.setAttribute('aria-hidden', 'false')
    })

    this.manageContainer.addEventListener('click', (event) => {
      if (event.target.closest('.pg-wishlist__manageContent')) return

      this.manageContainer.setAttribute('aria-hidden', 'true')
    })

    this.deleteEl.addEventListener('click', () => {
      const wishlist = this.deleteEl.dataset.wishlist

      const event = new CustomEvent(window.theme.wishlist.eventBus.wishlist_remove, {
        detail: {
          wishlist,
        },
      })

      this.deleteEl.textContent = this.deleteEl.dataset.textDeleting

      window.dispatchEvent(event)
    })

    this.editEl.addEventListener('click', () => {
      this.editInput.value = this.headingEl.innerText
      this.editUpdate.setAttribute('disabled', true)
      this.headingBlock.style.display = 'none'
      this.editDialog.style.display = 'flex'
      this.editInput.focus()
    })

    this.editCancel.addEventListener('click', () => {
      this.headingBlock.style.display = 'block'
      this.editDialog.style.display = 'none'
    })

    this.editInput.addEventListener('input', () => {
      if (this.editInput.value === this.headingEl.textContent || !this.editInput.checkValidity() || this.editInput.value.length === 0) {
        this.editUpdate.setAttribute('disabled', true)
      } else {
        this.editUpdate.removeAttribute('disabled')
      }
    })

    this.editUpdate.addEventListener('click', () => {
      const wishlist = this.dataset.wishlistId
      const newName = this.editInput.value

      const event = new CustomEvent(window.theme.wishlist.eventBus.wishlist_rename, {
        detail: {
          wishlist,
          newName,
        },
      })

      window.dispatchEvent(event)
    })

    window.addEventListener(window.theme.wishlist.eventBus.wishlist_renamed, (event) => {
      this.headingBlock.style.display = 'block'
      this.editDialog.style.display = 'none'
      this.showDefaultView()
    })
  }

  initialise () {
    const urlParams = new URLSearchParams(window.location.search)
    const wishlistId = urlParams.get('lid')

    if (wishlistId) {
      this.showSharedView(wishlistId)
    } else {
      this.showDefaultView()
    }
  }

  showSharedView (wishlistId) {
    this.fetchWishlist(wishlistId).then(wishlist => {
      if (wishlist) {
        this.showSingleView(wishlist, true)
      } else {
        this.showDefaultView()
      }
    })
  }

  async showDefaultView () {
    const wishlists = await this.fetchWishlists()

    if (wishlists.length) {
      this.showGridView()
    } else {
      this.showEmptyView()
    }
  }

  resetView () {
    this.dataset.wishlistId = ''
    this.gridEl.innerHTML = ''
    this.gridEl.classList.remove('pg-wishlist__grid--products')
    this.backEl.setAttribute('aria-hidden', 'true')
    this.manageEl.setAttribute('aria-hidden', 'true')

    this.headingEl.textContent = this.headingEl.dataset.text
    this.deleteEl.dataset.wishlist = ''
    this.deleteEl.textContent = this.deleteEl.dataset.textDelete

    this.manageContainer.setAttribute('aria-hidden', 'true')
  }

  showSingleView (wishlist, shared) {
    this.resetView()

    if (shared) {
      wishlist = wishlist.list
    }

    this.dataset.wishlistId = wishlist.lid
    this.gridEl.classList.add('pg-wishlist__grid--products')
    this.backEl.setAttribute('aria-hidden', 'false')

    this.wishlistName = wishlist.lprops?.name || wishlist.lname

    if (/^\d{12,}$/.test(wishlist.lname) || wishlist.lname.includes(wishlist.lid)) {
      this.wishlistName = 'Wishlist'
    }

    this.headingEl.textContent = this.wishlistName

    if (!shared) {
      this.manageEl.setAttribute('aria-hidden', 'false')
      this.deleteEl.dataset.wishlist = wishlist.lid
    }

    this.generateProductGrid(wishlist)

    if (wishlist.listcontents.length > 0) {
      this.gridEl.setAttribute('aria-hidden', 'false')
      this.emptyEl.setAttribute('aria-hidden', 'true')
    } else {
      this.gridEl.setAttribute('aria-hidden', 'true')
      this.emptyEl.setAttribute('aria-hidden', 'false')
    }
  }

  showGridView () {
    this.resetView()
    this.generateWishlistGrid()

    this.gridEl.setAttribute('aria-hidden', 'false')
    this.emptyEl.setAttribute('aria-hidden', 'true')
  }

  showEmptyView () {
    this.resetView()

    this.gridEl.setAttribute('aria-hidden', 'true')
    this.emptyEl.setAttribute('aria-hidden', 'false')
  }

  async generateWishlistGrid () {
    const wishlists = await this.fetchWishlists()

    wishlists.forEach(wishlist => {
      const wishlistEl = this.wishlistTemplate.content.cloneNode(true)
      const listItem = wishlistEl.querySelector('[data-wishlist-grid-el="item"]')
      const listItemInner = wishlistEl.querySelector('[data-wishlist-grid-el="inner"]')
      const title = wishlistEl.querySelector('[data-wishlist-grid-el="title"]')
      const count = wishlistEl.querySelector('[data-wishlist-grid-el="count"]')
      const products = wishlistEl.querySelector('[data-wishlist-grid-el="products"]')

      this.wishlistName = wishlist.lprops?.name || wishlist.lname

      if (/^\d{12,}$/.test(wishlist.lname) || wishlist.lname.includes(wishlist.lid)) {
        this.wishlistName = 'Wishlist'
      }

      title.textContent = this.wishlistName
      listItem.dataset.wishlistId = wishlist.lid
      count.textContent = `(${wishlist.listcontents.length})`

      wishlist.listcontents.forEach(product => {
        if (products.children.length >= 3) return
        const productEl = this.productTemplate.content.cloneNode(true)
        const link = productEl.querySelector('[data-wishlist-grid-el="link"]')
        const image = productEl.querySelector('[data-wishlist-grid-el="image"]')

        link.href = product.du
        image.src = product.iu
        image.alt = product.dt

        products.appendChild(productEl)
      })

      this.gridEl.appendChild(wishlistEl)

      listItemInner.addEventListener('click', (event) => {
        if (event.target.tagname === 'wishlist-share' || event.target.closest('wishlist-share')) return

        this.showSingleView(wishlist)
      })
    })
  }

  generateProductGrid (wishlist) {
    wishlist.listcontents.forEach(async product => {
      const cardEl = document.createElement('li')
      const cardHtml = await Promise.allSettled([this.fetchProductCard(product)]).then((res) => res[0].value)

      cardEl.classList.add('pg-wishlist__product')
      cardEl.innerHTML = cardHtml

      const deleteButton = document.createElement('button')
      deleteButton.classList.add('pg-wishlist__delete-product')
      deleteButton.innerHTML = '<span class="sr-only">Remove</span>'

      cardEl.appendChild(deleteButton)

      deleteButton.addEventListener('click', () => {
        const event = new CustomEvent(window.theme.wishlist.eventBus.wishlist_remove_product, {
          detail: {
            wishlistId: wishlist.lid,
            variantId: product.epi,
            productId: product.empi,
            productUrl: product.du,
          },
        })

        window.dispatchEvent(event)

        deleteButton.closest('li').remove()
      })

      this.gridEl.appendChild(cardEl)
    })
  }

  async fetchProductCard (product) {
    const { du: productUrl, epi: variantId } = product

    return fetch(
      `${window.location.origin}/products/${productUrl.split('products/')[1]}?section_id=product-card&variant=${variantId}`,
    )
      .then(res => res.text())
      .then(html => {
        return html
      })
      .catch(e => {
        console.error(e)
      })
  }

  fetchWishlists () {
    return new Promise((resolve) => {
      const onSuccess = function (wishlists) {
        // console.info('fetchWishlists() - Success', wishlists)

        resolve(wishlists)
      }
      const onError = function (error) {
        console.error('fetchWishlists() - Error', error)
      }

      window._swat.fetchLists({
        callbackFn: onSuccess,
        errorFn: onError,
      })
    })
  }

  fetchWishlist (wishlistId) {
    return new Promise((resolve) => {
      const listConfig = {
        lid: wishlistId,
      }
      const onSuccess = function (wishlist) {
        // console.info('fetchWishlist() - Success', wishlist)

        resolve(wishlist)
      }
      const onError = function (error) {
        console.error('fetchWishlist() - Error', error)
      }

      window._swat.fetchListDetails(listConfig, onSuccess, onError)
    })
  }
}

customElements.define('wishlist-grid', WishlistGrid)
